import React from 'react';
import classnames from 'classnames';
import { useTheme } from '../theme';

type HeaderVariant = 'default' | 'elevated';

export type HeaderProps = { variant?: HeaderVariant } & React.HTMLAttributes<HTMLDivElement>;

export const Header = ({
  variant = 'default',
  className,
  ...props
}: HeaderProps): React.ReactElement => {
  const theme = useTheme();
  const classNames = classnames(className, 'airtame-header', `airtame-header--variant-${variant}`);
  return <div className={classNames} data-theme={theme} {...props} />;
};

Header.displayName = 'Header';
